export default __webpack_public_path__ + "static/media/distance.f97903ff.svg";